<template>
  <div class="course-plaza-box">
    <courseFilter @change-filter="changeFilter" :assignType="assignType" />
    <div class="list-box">
      <div class="list-top-info">
        <div>
          <span
            :class="{ 'current-order': currentSort === 1 }"
            @click="changeOrder(1)"
            >最新</span
          >
          <span
            :class="{ 'current-order': currentSort === 2 }"
            @click="changeOrder(2)"
            >最热</span
          >
        </div>
        <p>
          共<span>{{ total }}</span
          >个课程
        </p>
      </div>
      <div v-if="total > 0" class="course-list">
        <courseItem
          v-for="item in courseList"
          :key="item.id"
          :info="item"
          @refresh="getCourseList"
        />
      </div>
      <div v-else class="no-data">
        <img src="../../assets/images/create-college/not-data.png" alt="" />
        <p>暂无课程</p>
      </div>
      <div v-if="total > 15" class="pagination-box">
        <el-pagination
          background
          layout="prev, pager, next, jumper"
          :page-size="pageSize"
          :total="total"
          :current-page.sync="pageIndex"
          @current-change="changePage"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../assets/js/api";
import courseFilter from "./course-filter.vue";
import courseItem from "./course-item.vue";
export default {
  name: "ShopCenterAdminWebCoursePlaza",
  components: {
    courseFilter,
    courseItem,
  },
  props: {
    assignType: {
      type: String,
      default: null,
    },
    keyword: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      currentSort: 1,
      currentType: 1,
      currentSubject: 1,
      total: 0,
      courseList: [],
      pageIndex: 1,
      pageSize: 15,
    };
  },

  watch: {
    keyword: {
      handler() {
        this.courseList = [];
        this.total = 0;
        this.pageIndex = 1;
        this.getCourseList();
      },
    },
  },

  mounted() {},

  methods: {
    changeOrder(sort) {
      this.currentSort = sort;
      this.getCourseList();
    },
    changeFilter(filter) {
      this.currentType = filter.currentType;
      this.currentSubject = filter.currentSubject;
      this.pageIndex = 1;
      this.getCourseList();
    },
    changePage() {
      this.getCourseList();
    },
    async getCourseList() {
      const params = {
        sortRule: this.currentSort,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      if (this.currentType !== -1) {
        params.categoryIds = this.currentSubject || [this.currentType];
      }
      if (this.keyword) {
        params.title = this.keyword;
      }
      const res = await this.$axios.post(
        api.creatCollege.getCourseList,
        params
      );
      // console.log("课程广场----", res);
      if (res.valid) {
        this.courseList = [...res.result.list];
        this.total = res.result.totalCount;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.course-plaza-box {
  min-width: 1080px;
  border-radius: 5px;
  background: #fff;
  .list-box {
    padding: 20px 40px;
    .list-top-info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      & > div {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        & > span {
          margin-right: 18px;
          color: #333;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 14px;
          cursor: pointer;
          &:last-child {
            margin-right: 0;
          }
          &:hover {
            color: #6384f7;
          }
        }
        .current-order {
          color: #6384f7;
        }
      }
      & > p {
        color: #80848b;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 14px;
        & > span {
          color: #6384f7;
        }
      }
    }
    .course-list {
      display: grid;
      grid-template-columns: repeat(5, 18.2%);
      grid-template-rows: 240px;
      column-gap: 2%;
      row-gap: 30px;
      grid-auto-rows: 240px;
      // place-items: left;
    }
    .no-data {
      height: 360px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      & > img {
        width: 160px;
        height: 208px;
        margin-bottom: 22px;
      }
      & > p {
        color: #999;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }
    .pagination-box {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: 30px;
    }
  }
}
</style>
